<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/atencionfacturacion">Atenciones Médicas</router-link>
            &rsaquo; Atención {{ datoAtencion.numero }}
          </div>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue;cursor:pointer"
            @click="showModalHelp = true">help</span>
        </div>
      </div>
    </div>

    <!-- Notificaciones -->
    <div v-for="(n, i) in notificaciones" :key="i" class="notification-area">
      <div class="notification-message"
           :class="{ 'is-success': n.type === 'success', 'is-error': n.type === 'error' }">
        {{ n.message }}
      </div>
    </div>

    <Modal v-model:modelValue="showModalHelp">
      <AyudaGeneracionPlanilla />
    </Modal>

    <hr>

    <!-- ── Master ──────────────────────────────────────────────── -->
<div class="mb-3">

  <!-- Barra de control: toggle izquierda, acciones derecha -->
  <div class="resumen-barra mb-2">
    <button class="btn-toggle-meta" @click="mostrarBloque = !mostrarBloque">
      <span class="material-symbols-outlined" style="font-size:16px">
        {{ mostrarBloque ? 'expand_less' : 'expand_more' }}
      </span>
      {{ mostrarBloque ? 'Menos información' : 'Más información' }}
    </button>

    <div class="d-flex gap-2">
      <button class="btn btn-success btn-sm d-flex align-items-center gap-1"
              @click="callGenerarFactura(datoAtencion.idAtencion)"
              v-if="datoAtencion.estadoAtencion === 'FINALIZADA'">
        <i class="material-icons" style="font-size:18px">post_add</i>
        Generar factura
      </button>
      <button class="btn btn-outline-success btn-sm d-flex align-items-center gap-1"
              @click="editarFactura(datoAtencion.idFactura)"
              v-if="datoAtencion.estadoAtencion === 'FACTURADA'">
        <i class="material-icons" style="font-size:18px">receipt_long</i>
        Editar factura
      </button>
      <button class="btn btn-outline-success btn-sm d-flex align-items-center gap-1"
              @click="verFactura(datoAtencion.idFactura)"
              v-if="datoAtencion.estadoAtencion === 'FACTURADA'">
        <i class="material-icons" style="font-size:18px">receipt_long</i>
        Ver factura
      </button>
    </div>
  </div>

  <!-- Bloque expandido -->
  <div v-if="mostrarBloque">
    <div class="resumen-card mb-3">
      <div class="resumen-grid-4 mb-3">
        <div class="resumen-campo">
          <span class="resumen-lbl">Número</span>
          <span class="resumen-val fw-500">{{ datoAtencion.numero }}</span>
        </div>
        <div class="resumen-campo">
          <span class="resumen-lbl">Fecha de la cita</span>
          <span class="resumen-val">{{ getFormattedDate(datoAtencion.fechaCita) }}</span>
        </div>
        <div class="resumen-campo">
          <span class="resumen-lbl">Estado</span>
          <span class="badge-estado" :class="getClassEstado(datoAtencion.estadoAtencion)">
            {{ datoAtencion.estadoAtencion }}
          </span>
        </div>
      </div>

      <hr class="resumen-divider">

      <div class="resumen-grid-2 mb-3">
        <div class="resumen-campo">
          <span class="resumen-lbl">Paciente</span>
          <span class="resumen-val">{{ datoAtencion.nombrePaciente }}</span>
        </div>
        <div class="resumen-campo">
          <span class="resumen-lbl">Cédula</span>
          <span class="resumen-val">{{ datoAtencion.documentoPaciente }}</span>
        </div>
      </div>

      <div class="resumen-grid-2 mb-3">
        <div class="resumen-campo">
          <span class="resumen-lbl">Médico</span>
          <span class="resumen-val">{{ datoAtencion.nombreMedico }}</span>
        </div>
        <div class="resumen-campo">
          <span class="resumen-lbl">Especialidad</span>
          <span class="resumen-val">{{ datoAtencion.nombreEspecialidad }}</span>
        </div>
      </div>

      <div class="resumen-campo">
        <span class="resumen-lbl">Observación</span>
        <span class="resumen-val" style="text-transform:uppercase">
          {{ datoAtencion.observacion || '—' }}
        </span>
      </div>
    </div>

    <!-- Diagnósticos -->
    <div class="resumen-card mb-3">
      <p class="resumen-seccion-titulo">Diagnósticos</p>
      <DataTableBasic
        :data="diagnosticos" :columns="columnasDiag" idField="idDiagAten"
        :mostrarBotonTodos="false" :mostrarBotonNuevo="false" :mostrarBotonExcel="false"
        :mostrarInfo="false" :mostrarEditar="false" :mostrarVer="false"
        :mostrarEliminar="false" :acciones="false"
        @refresh="getDataDiagnosticos"
      >
        <template #cell-tipo="{ row }">{{ valorTipoDiag(row.tipo) }}</template>
      </DataTableBasic>
    </div>
  </div>

  <!-- Bloque colapsado -->
  <div v-else class="resumen-card resumen-colapsado">
    <span class="resumen-val fw-500">{{ datoAtencion.numero }}</span>
    <span class="resumen-separador">·</span>
    <span class="resumen-val">{{ datoAtencion.nombrePaciente }}</span>
    <span class="resumen-separador">·</span>
    <span class="badge-estado" :class="getClassEstado(datoAtencion.estadoAtencion)">
      {{ datoAtencion.estadoAtencion }}
    </span>
  </div>

</div>

    <!-- ── Detalle de planilla ─────────────────────────────────── -->
    <hr>
    <DataTable
      :data="atenciondets"
      :columns="columnas"
      idField="idAtencionDet"
      :mostrarBotonTodos="false"
      :mostrarBotonExcel="false"
      :mostrarInfo="false"
      :mostrarVer="false"
      :mostrarEliminar="esFinalizada"
      :mostrarEditar="esFinalizada"
      :mostrarBotonNuevo="esFinalizada"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idAtencionDet)"
      @delete="row => deleteAtencionDet(row.idAtencionDet)"
      @refresh="getDataTodos"
    >
      <template #cell-precioTotal="{ row }">
        {{ formatMoneda(row.cantidad * row.precioUnitario) }}
      </template>

      <template #footer-extra>
        <tr class="table-secondary fw-bold">
          <td :colspan="columnas.length - 1" class="text-end">Sub-Total:</td>
          <td class="text-end">{{ formatMoneda(totalPrecioTotal) }}</td>
          <td class="text-end">{{ formatMoneda(totalIVA) }}</td>
          <td v-if="esFinalizada"></td>
        </tr>
        <tr class="table-secondary fw-bold">
          <td :colspan="columnas.length - 1" class="text-end">TOTAL:</td>
          <td colspan="2" class="text-end">{{ formatMoneda(totalPrecioTotal + totalIVA) }}</td>
          <td v-if="esFinalizada"></td>
        </tr>
      </template>
    </DataTable>

    <!-- ── Modal detalle ──────────────────────────────────────── -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
         aria-labelledby="modalDetLabel" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">

          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalDetLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Cerrar"></button>
          </div>

          <div class="modal-body">

            <!-- Id (solo edición) -->
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-3"><label class="form-label">Id detalle</label></div>
                <div class="col-9">
                  <input type="text" class="form-control"
                         v-model="datoAtencionDet.idAtencionDet" disabled>
                </div>
              </div>
            </div>

            <!-- Buscador elemento -->
            <div class="mb-3">
              <div class="row">
                <div class="col-3"><label class="form-label">Elemento</label></div>
                <div class="col-9">
                  <div class="input-group">
                    <input type="text" class="form-control"
                           v-model="searchTextElem"
                           @input="filterElementos"
                           @keyup.enter="toggleDropdown"
                           placeholder="Buscar elemento...">
                    <button class="btn btn-outline-secondary dropdown-toggle"
                            type="button" data-bs-toggle="dropdown"
                            aria-expanded="false" ref="dropdownButton">
                      <i class="fa fa-search"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end shadow"
                        style="max-height:250px;overflow-y:auto;width:100%"
                        ref="dropdownMenu">
                      <li v-for="e in filteredElementos" :key="e.idElemEmpr">
                        <a class="dropdown-item text-truncate" href="#"
                           @click.prevent="selectElemento(e)" :title="e.nombre">
                          {{ e.codigo }} — {{ e.nombre }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Impuesto (solo lectura) -->
            <div class="mb-3">
              <div class="row">
                <div class="col-3"><label class="form-label">Impuesto</label></div>
                <div class="col-3">
                  <input type="text" class="form-control"
                         v-model="datoAtencionDet.impuestoNombre" disabled>
                </div>
                <div class="col-3"><label class="form-label">Valor impuesto</label></div>
                <div class="col-3">
                  <input type="number" class="form-control"
                         v-model="datoAtencionDet.impuestoValor" disabled>
                </div>
              </div>
            </div>

            <!-- Cantidad y precio -->
            <div class="mb-3">
              <div class="row">
                <div class="col-3"><label class="form-label">Cantidad</label></div>
                <div class="col-3">
                  <input type="number" class="form-control" min="1"
                         v-model.number="datoAtencionDet.cantidad" required>
                </div>
                <div class="col-3"><label class="form-label">Precio unitario</label></div>
                <div class="col-3">
                  <input type="number" class="form-control" min="0" step="0.01"
                         v-model.number="datoAtencionDet.precioUnitario">
                </div>
              </div>
            </div>

            <!-- Total calculado (vista previa) -->
            <div class="mb-1 text-end text-muted" style="font-size:0.85rem"
                 v-if="datoAtencionDet.cantidad && datoAtencionDet.precioUnitario">
              Total línea:
              <strong>
                {{ formatMoneda(datoAtencionDet.cantidad * datoAtencionDet.precioUnitario) }}
              </strong>
            </div>

          </div>

          <div class="modal-footer">
            <button class="btn btn-primary d-flex align-items-center gap-1"
                    @click.prevent="guardarAtencionDet" v-if="btnCrear_det">
              <i class="material-icons" style="font-size:20px">save</i>
              Guardar
            </button>
            <button class="btn btn-primary d-flex align-items-center gap-1"
                    @click.prevent="guardarEditAtencionDet" v-if="btnEditar_det">
              <i class="material-icons" style="font-size:20px">update</i>
              Actualizar
            </button>
          </div>

        </div>
      </div>
    </div>
    <Modal v-model:modelValue="showModalFactura" title="Factura">
      <Factura_FacturaDet v-if="idFacturaVer" :p_idFactura="idFacturaVer" />
    </Modal>
    <Footer />
  </div>
</template>

<script>
import Layout                   from '@/components/Layout.vue'
import Footer                   from '@/components/Footer.vue'
import Factura_FacturaDet       from '@/views/masterDetails/Factura_FacturaDet.vue'
import DataTable                from '@/components/DataTable.vue'
import DataTableBasic           from '@/components/DataTableBasic.vue'
import AyudaGeneracionPlanilla  from '@/views/ayuda/AyudaGeneracionPlanilla.vue'
import { validarForm }          from '@/modules/validacionesForms.js'
import dateFormat               from '@/modules/dateFormat.js'
import { decodificarTipoDiag }  from '@/modules/decode.js'
import api                      from '@/services/api'
import swal2                    from 'sweetalert2'
import * as $                   from 'jquery'

window['$']      = $
window['jQuery'] = $

export default {
  name: 'AtencionFacturacion',
  components: { Layout, Footer, DataTable, DataTableBasic, AyudaGeneracionPlanilla, Factura_FacturaDet },

  data() {
    return {
      // Master
      datoAtencion:      {},
      p_idAtencion:      '',
      mostrarBloque:     true,
      showModalHelp:     false,
      showModalFactura:  false,
      idFacturaVer:      null,
      notificaciones:    [],
      // Detalle
      atenciondets:      [],
      datoAtencionDet:   {},
      titulo:            '',
      btnCrear_det:      false,
      btnEditar_det:     false,
      modalWindow:       true,
      elemEmprs:         [],
      filteredElementos: [],
      searchTextElem:    '',
      columnas: [
        { field: 'elementoCodigo', label: 'Código' },
        { field: 'elementoNombre', label: 'Nombre' },
        { field: 'cantidad',       label: 'Cantidad' },
        { field: 'precioUnitario', label: 'Precio unitario' },
        { field: 'precioTotal',    label: 'Precio total' },
        { field: 'impuestoValor',  label: 'Valor IVA' },
      ],
      diagnosticos: [],
      columnasDiag: [
        { field: 'diagnosticoCodigo', label: 'Código' },
        { field: 'diagnosticoNombre', label: 'Diagnóstico' },
        { field: 'tipo',              label: 'Tipo' },
      ],
    }
  },

  computed: {
    esFinalizada() {
      return this.datoAtencion.estadoAtencion === 'FINALIZADA'
    },
    totalPrecioTotal() {
      return this.atenciondets.reduce((acc, d) => acc + d.cantidad * d.precioUnitario, 0)
    },
    totalIVA() {
      return this.atenciondets.reduce((acc, d) => acc + (d.impuestoValor ?? 0), 0)
    },
  },

  mounted() {
    this.p_idAtencion = this.$route.params.p_idatencion
    this.abrirEditar(this.p_idAtencion)
    this.getDataTodos()
    this.getDataDiagnosticos()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },

  methods: {
    // ── Utilidades ──────────────────────────────────────────────
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    formatMoneda(valor) {
      return Number(valor ?? 0).toFixed(2)
    },

    valorTipoDiag(codigo) {
      return decodificarTipoDiag(codigo)
    },

    getClassEstado(estado) {
      return {
        'FINALIZADA':  'badge-finalizada',
        'FACTURADA':   'badge-facturada',
        'EN PROCESO':  'badge-en-proceso',
        'CANCELADA':   'badge-cancelada',
      }[estado] || ''
    },

    // ── Master ───────────────────────────────────────────────────
    abrirEditar(idAtencion) {
      if (idAtencion) {
        api.get('/vwatencions/' + idAtencion)
          .then(r => { this.datoAtencion = r.data })
          .catch(e => console.error('Error cargando atención:', e))
      }
    },

    // ── Detalle ──────────────────────────────────────────────────
    getDataTodos() {
      api.get('/vwatenciondetexts/idatencion/' + this.p_idAtencion)
        .then(r  => { this.atenciondets = r.data.reverse() })
        .catch(e => console.error('Error cargando detalles:', e))
    },

    getDataDiagnosticos() {
      api.get('/vwdiagatens/idatencion/' + this.p_idAtencion)
        .then(r  => { this.diagnosticos = r.data })
        .catch(e => console.error('Error cargando diagnósticos:', e))
    },

    validarDetalle() {
      // Validación específica del detalle, no del master
      const campos    = ['idElemEmpr', 'cantidad', 'precioUnitario']
      const etiquetas = ['"Elemento"', '"Cantidad"', '"Precio unitario"']
      return validarForm(this.datoAtencionDet, campos, etiquetas)
    },

    async guardarAtencionDet() {
      if (this.validarDetalle() !== 1) return
      try {
        this.datoAtencionDet.idAtencion = this.datoAtencion.idAtencion
        await api.post('/atenciondets', this.datoAtencionDet)
        $('#ventanaModal').modal('hide')
        swal2.fire({ icon: 'success', title: 'Guardado', text: 'Elemento agregado correctamente.', timer: 1500, showConfirmButton: false })
        this.getDataTodos()
      } catch (error) {
        swal2.fire({ icon: 'error', title: 'Error', text: 'No se pudo guardar el elemento.' })
      }
    },

    async guardarEditAtencionDet() {
      if (this.validarDetalle() !== 1) return
      try {
        await api.post('/atenciondets', this.datoAtencionDet)
        $('#ventanaModal').modal('hide')
        swal2.fire({ icon: 'success', title: 'Actualizado', text: 'Elemento actualizado correctamente.', timer: 1500, showConfirmButton: false })
        this.getDataTodos()
      } catch (error) {
        swal2.fire({ icon: 'error', title: 'Error', text: 'No se pudo actualizar el elemento.' })
      }
    },

    abrirModalCrear() {
      this.modalWindow     = true
      this.datoAtencionDet = {}
      this.searchTextElem  = ''
      this.titulo          = 'Agregar elemento'
      this.btnCrear_det    = true
      this.btnEditar_det   = false
      this.fetchElemEmprs()
      this.$nextTick(() => $('#ventanaModal').modal('show'))
    },

    abrirModalEditar(idAtencionDet) {
      this.modalWindow     = true
      this.titulo          = 'Editar elemento'
      this.btnCrear_det    = false
      this.btnEditar_det   = true
      this.searchTextElem  = ''
      api.get('/vwatenciondetexts/' + idAtencionDet)
        .then(r => {
          this.datoAtencionDet = r.data
          this.searchTextElem  = `${r.data.elementoCodigo} — ${r.data.elementoNombre}`
        })
      this.fetchElemEmprs()
      this.$nextTick(() => $('#ventanaModal').modal('show'))
    },

    async deleteAtencionDet(idAtencionDet) {
      const { isConfirmed } = await swal2.fire({
        title:              '¿Eliminar elemento?',
        text:               'Esta acción no se puede deshacer.',
        icon:               'warning',
        showCancelButton:   true,
        confirmButtonText:  'Sí, eliminar',
        confirmButtonColor: '#f76c6c',
        cancelButtonText:   'Cancelar',
        cancelButtonColor:  '#6c757d',
      })
      if (!isConfirmed) return
      try {
        await api.delete('/atenciondets/' + idAtencionDet)
        this.getDataTodos()
      } catch {
        swal2.fire({ icon: 'error', title: 'Error', text: 'No se pudo eliminar el elemento.' })
      }
    },

    fetchElemEmprs() {
      api.get('/vwelememprs/idempresa/' + window.sessionStorage.getItem('idEmpresa'))
        .then(r => {
          this.elemEmprs         = r.data
          this.filteredElementos = r.data
        })
        .catch(e => console.error('Error fetching elementos:', e))
    },

    filterElementos() {
      const q = this.searchTextElem.toLowerCase()
      this.filteredElementos = this.elemEmprs.filter(e =>
        e.nombre.toLowerCase().includes(q) || e.codigo.toLowerCase().includes(q)
      )
    },

    selectElemento(elemEmpr) {
      this.datoAtencionDet.idElemEmpr     = elemEmpr.idElemEmpr
      this.searchTextElem                 = `${elemEmpr.codigo} — ${elemEmpr.nombre}`
      this.datoAtencionDet.precioUnitario = elemEmpr.valor
      this.datoAtencionDet.cantidad       = 1
      this.datoAtencionDet.idImpuesto     = elemEmpr.idImpuesto
      this.datoAtencionDet.impuestoNombre = elemEmpr.impuestoNombre
      this.datoAtencionDet.impuestoValor  = elemEmpr.valor
    },

    toggleDropdown() {
      this.$refs.dropdownButton.click()
    },

    // ── Factura ──────────────────────────────────────────────────
    async callGenerarFactura(idAtencion) {
      if (this.totalPrecioTotal <= 0) {
        swal2.fire({
          icon: 'warning',
          title: 'Sin elementos',
          text:  'Registre al menos un elemento en el detalle de la planilla.',
        })
        return
      }
      const { isConfirmed } = await swal2.fire({
        title:              '¿Generar factura?',
        text:               `Se creará la factura por $${this.formatMoneda(this.totalPrecioTotal + this.totalIVA)}.`,
        icon:               'question',
        showCancelButton:   true,
        confirmButtonText:  'Sí, generar',
        confirmButtonColor: '#3085d6',
        cancelButtonText:   'Cancelar',
        cancelButtonColor:  '#6c757d',
      })
      if (!isConfirmed) return

      try {
        const { data } = await api.post(
          `/facturas/generarPorAtencion/${idAtencion}/` +
          `${window.sessionStorage.getItem('idEmpresa')}/` +
          `${window.sessionStorage.getItem('idUsuario')}`
        )
        if (data?.idFactura) {
          const result = await swal2.fire({
            title:              '¡Factura creada!',
            text:               '¿Deseas ver los detalles ahora?',
            icon:               'success',
            showCancelButton:   true,
            confirmButtonText:  'Ver factura',
            confirmButtonColor: '#3085d6',
            cancelButtonText:   'Más tarde',
            cancelButtonColor:  '#6c757d',
          })
          if (result.isConfirmed) {
            this.$router.push('/facturaform/' + data.idFactura)
            const idAtencion = this.datoAtencion.idAtencion
            const idFactura  = data?.idFactura
            const numero     = this.datoAtencion.numero
            this.$router.push({
              path: '/facturaform',
              state: { idAtencion, idFactura, numero }
            });			
            return
          }
        }
        this.getDataTodos()
        this.abrirEditar(this.p_idAtencion)
      } catch (error) {
        swal2.fire({ icon: 'error', title: 'Error', text: 'No se pudo generar la factura. Inténtelo de nuevo.' })
        console.error(error)
      }
    },

    verFactura(idFactura) {
      this.idFacturaVer     = idFactura
      this.showModalFactura = true
    },
	
    editarFactura(idFactura) {
      const idAtencion = this.p_idAtencion;
      const numero     = this.datoAtencion.numero;
      this.$router.push({
        path: '/facturaform',
        state: { idAtencion, idFactura, numero }
      });
    },
	
  },
}
</script>

<style src="@/assets/css/listaFiltrada02.css" scoped></style>

<style scoped>
/* ── Resumen master ───────────────────────────── */
.resumen-card {
  background: #fff;
  border: 0.5px solid #dee2e6;
  border-radius: 8px;
  padding: 1rem 1.25rem;
}
.resumen-grid-2 { display: grid; grid-template-columns: repeat(2, minmax(0,1fr)); gap: 12px; }
.resumen-grid-4 { display: grid; grid-template-columns: repeat(4, minmax(0,1fr)); gap: 12px; }
.resumen-campo  { display: flex; flex-direction: column; }
.resumen-lbl {
  font-size: 11px; font-weight: 500; color: #6c757d;
  text-transform: uppercase; letter-spacing: .04em; margin-bottom: 2px;
}
.resumen-val { font-size: 14px; color: #212529; }
.fw-500      { font-weight: 500; }
.resumen-divider { border: none; border-top: 0.5px solid #dee2e6; margin: 12px 0; }
.resumen-seccion-titulo { font-size: 13px; font-weight: 500; margin: 0 0 10px; }
.resumen-footer {
  display: flex; gap: 8px;
  padding-top: 12px; border-top: 0.5px solid #dee2e6; margin-top: 12px;
}

/* ── Toggle metadatos ─────────────────────────── */
.btn-toggle-meta {
  background: none; border: none; color: #6c757d;
  font-size: 12px; cursor: pointer; padding: 0;
  display: flex; align-items: center; gap: 4px;
}

/* ── Badges estado ────────────────────────────── */
.badge-estado {
  display: inline-block; padding: 3px 10px;
  border-radius: 4px; font-size: 12px; font-weight: 500;
}
.badge-finalizada { background-color: #d4edda; color: #155724; }
.badge-facturada  { background-color: #cce5ff; color: #004085; }
.badge-en-proceso { background-color: #cff4fc; color: #055160; }
.badge-cancelada  { background-color: #f8d7da; color: #721c24; }

@media (max-width: 576px) {
  .resumen-grid-2,
  .resumen-grid-4 { grid-template-columns: 1fr; }
}

.resumen-colapsado {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 1.25rem;
}
.resumen-separador {
  color: #adb5bd;
  font-size: 14px;
}

.resumen-barra {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>